module.exports = __webpack_public_path__ + "img/spinner-medium.6ecbfb22.svg";